import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import useTableScroll from "../components/useTableScroll.js";

import { Mensaje } from '../components/mensajes';
import axios from "axios";
import { formatMoneda } from '../util/varios.js';

import { Dimmer } from "../components/spinner";
const CatalogoCuentasObras = props => {

    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const espiritu = JSON.parse(localStorage.getItem("espiritu"));

    const btnCancela = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [values, setValues] = useState({});
    const [activo, setActivo] = useState(true);
    const [valor, setValor] = useState(0.00);
    const [itemSelect, setItemSelect] = useState(-1);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const headCells = [
        { id: 'auxiliar', label: 'ORDINAL', width: '20px', textAlign: 'center', backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        { id: 'categoriaprogramatica', label: 'CATEGORIA', width: '50px', textAlign: 'center', backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        { id: 'descripcionaux', label: 'DESCRIPCIÓN', width: '300px', textAlign: 'center', backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        { id: 'sectorgeog', label: 'UBICACION', width: '150px', textAlign: 'center', backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        { id: 'monto', label: 'MONTO', width: '120px', textAlign: 'center', backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableScroll(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.categoriaprogramatica.includes(target.value)
                            || x.auxiliar.includes(target.value.toLowerCase())
                            || x.descripcionaux.toLowerCase().includes(target.value.toLowerCase())
                            || x.sectorgeog.toLowerCase().includes(target.value.toLowerCase())
                            || formatMoneda(x.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2).includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const seleccionarRegistros = () => {

        setActivate(true);
        var auxi = "c.auxiliar != '000000'";
        var auxiliar = "'000000'";
        if (espiritu === 9 || espiritu === 12 || espiritu === 13 || espiritu === 14 || espiritu === 8 || espiritu === 0 || espiritu === 2 || espiritu === 7 || espiritu === 1 || espiritu === 15) {
            auxi = " true ";
            if (espiritu === 9 || espiritu === 12 || espiritu === 14 || espiritu === 2 || espiritu === 0 || espiritu === 1 || espiritu === 13 || espiritu === 15) {
                auxiliar = "'0000'";
            }
        }
        let endpoint = `${op.conexion}/api/presupuesto/catalogocuentasobras?idefiscal=${idefiscal}&auxi=${auxi}&auxiliar=${auxiliar}`
        console.log(endpoint);
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {

                setActivate(false);
                /*var datos = []
                for (let i = 0; i < response.data.length; i++) {
                    datos.push({
                        idcuenta: response.data[i].idcuenta,
                        cuenta: response.data[i].cuenta,
                        auxiliar: response.data[i].auxiliar,
                        descripcion: response.data[i].descripcion,
                        disponible: response.data[i].disponibilidad,
                        idcat: response.data[i].idcategoriaprogramatica,
                        idpuc: response.data[i].idpuc,
                        descripcionaux: response.data[i].descripcionaux,
                        aumentado: response.data[i].aumentado,
                        disminuido: response.data[i].disminuido,
                        precomprometido: response.data[i].precomprometido,
                        montoinicial: response.data[i].montoinicial,
                        comprometido: response.data[i].comprometido,
                        proyecto: response.data[i].proyecto,
                    })
                }
                setRecords(datos)*/
                setRecords(response.data)
            }

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        }).finally(function () {
            setActivate(false);
        });
    }

    const seleccionarPrecompromiso = (id) => {

        setActivate(true);

        let endpoint = `${op.conexion}/api/presupuesto/precompromiso?id=${id}`
        console.log(endpoint);
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {

                if (response.data.compro > 0) {
                    setValor(response.data.compro);
                } else {
                    setValor(0.00);
                }

                setActivate(false);

            }

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        }).finally(function () {
            setActivate(false);
        });
    }

    const blanquear = () => {
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
        setItemSelect("");
        setActivo(true);
    }


    const cancelar = () => {

        blanquear();
        props.onHideCancelar();
    }

    const seleccionarClassPresupuestaria = () => {
        blanquear();
        props.onHideAceptar(values.auxiliar, values.categoriaprogramatica, values.descripcionaux, values.monto, values.proyecto);
        props.onHideCancelar();
    };

    const seleccionarFila = (index) => (e) => {
        e.preventDefault();
        setActivo(false);
        setItemSelect(index);
        setValues({
            auxiliar: recordsAfterPagingAndSorting()[index].auxiliar,
            categoriaprogramatica: recordsAfterPagingAndSorting()[index].categoriaprogramatica,
            descripcionaux: recordsAfterPagingAndSorting()[index].descripcionaux,
            monto: recordsAfterPagingAndSorting()[index].monto,
            proyecto: recordsAfterPagingAndSorting()[index].proyecto,
        });

    };

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            size="lg"
            backdrop="static"
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            keyboard={false}
            onShow={() => {
                seleccionarRegistros()
            }}
        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className="fw-bold text-light"><h3>Cuentas Presupuestarias</h3></div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
                <Dimmer active={activate} inverted>

                </Dimmer>
                <div className="col-md-12 m-0">

                    <div className="input-group input-group-sm mb-3 m-0 col-md-5">
                        <input type='text'
                            onChange={handleSearch} className="form-control rounded-pill search-input" />
                    </div>
                </div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={index} style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)} >
                                        <td className='py-2 text-center' style={{ width: '20px' }}>{item.auxiliar}</td>
                                        <td className='py-2 text-center' style={{ width: '50px' }}>{item.categoriaprogramatica.trim()}</td>
                                        <td className='py-2 text-left' style={{ width: '300px' }}>{item.descripcionaux.trim()}</td>
                                        <td className='py-2 text-,left' style={{ width: '150px' }}>{item.sectorgeog.trim()}</td>
                                        <td className='py-2 text-right' style={{ width: '120px' }}>{formatMoneda(item.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-success rounded-pill" disabled={activo} style={{ margin: "5px" }} onClick={seleccionarClassPresupuestaria}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoCuentasObras;